module.exports = __webpack_public_path__ + "img/hand_side3_Blank.4cab4213.svg";